module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatter"
  }, [_c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "88%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439614785_i0004.jpg",
      "src": "images/e9781439614785_i0004.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("AMATEUR EXCITEMENT.")]), _vm._v(" Taken a few year after big time bouts had returned to Chicago, this terrific 1929 ringside photo captures the thrill of amateur boxing kept alive during the “boxing in limbo” era in the city. Depsite the fixed Gans-McGovern bout in 1900 sending marquee")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "88%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439614785_i0005.jpg",
      "src": "images/e9781439614785_i0005.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("fighters and championship matches out of town for a whole quarter-century "), _c('em', {
    staticClass: "i"
  }, [_vm._v("(see Chapter Two)")]), _vm._v(", Chicagoans continued to embrace the sport as much as anyone in the country. Note the packed house and the excited young fan to the left.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "87%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439614785_i0006.jpg",
      "src": "images/e9781439614785_i0006.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE CHICAGO COLISEUM.")]), _vm._v(" The Coliseum was constructed in 1889 of bricks and stones from the Notorius Libby prison in Richmond, Virginia where Union prisoners were kept by their Confederate captors during the Civil War. The Coliseum was erected between 14th and 16th Street on Wabash Avenue as the Libby Prison Museum. It was rebuilt once more as the Chicago Coliseum in 1900 and became the scene of the first national auto show that year. In 1904, it was used for the Republican Party which nominated Theodore Roosevelt, and it became the number one convention site for many years. It also housed other events such as Circuses, Wild West shows, Travel Expositions, etc. Professional sports made their debut at the Coliseum with wrestling and the newly formed Chicago Blackhawks Hockey team. Boxing became legal and in 1926, Mickey Walker won the middleweight title from Tiger Flowers in the first of several championship fights held there. It was promoted by an African American named Fred Irvin.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5aad9a6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781439614785_fm03.vue
// module id = 81
// module chunks = 0